import BigPicture from "bigpicture";
import { tns } from "tiny-slider/src/tiny-slider";
import "tiny-slider/dist/tiny-slider.css";

document.addEventListener("DOMContentLoaded", function (event) {

    var button = document.querySelector('[data-behaviour="menubutton"]');
    button.addEventListener("click", function (event) {
        document.body.classList.toggle("body--showmenu");
    })

    var toggles = document.querySelectorAll('[data-behaviour="section-toggle"]');
    toggles.forEach(toggle => {
        toggle.addEventListener("click", function (event) {
            toggle.parentNode.classList.toggle("section_text--open");
        })
    });

    var elements = [...document.querySelectorAll('[data-behaviour="lightbox"]')];

    elements.forEach(elem => {
        elem.addEventListener("click", e => {
            e.preventDefault();
            BigPicture({
                el: e.target,
                // ytSrc: 'z_PeaHVcohg',
                // imgSrc: elem.href,
                gallery: e.target.parentNode.parentNode.querySelectorAll("img")
            });
        });
    });

    var slider = document.querySelector('[data-behaviour="slider"]');

    if(slider) {
        var slider = tns({
            container: '[data-behaviour="slider"]',
            items: 1,
            slideBy: 'page',
            autoplay: false,
            navAsThumbnails: true,
            nav: false,
            controlsText: ['&lt;', '&gt;'],
            mouseDrag: true,
        });
    }

});
